import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/jsx-props-no-spreading */
import { TooltipInfos } from "@/components";
import { useFeaturesEnabled } from "@/contexts/cdpConfig";
import { useContactContext } from "@/contexts/contact";
import { useI18n } from "@/contexts/i18n";
import { useContactingTestId, useFeatureEnabled, useTrackingLeadFormError, } from "@/hooks";
import { Box } from "@gemini/core";
import { InfoCircleIcon } from "@gemini/icons";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { LegalText } from "./LegalText";
import { SuggestPriceButton } from "../Buttons/SuggestPriceButton";
import { ContactFormEnrichment } from "./ContactFormEnrichment";
import { ContactFormPlato } from "./ContactFormPlato";
import { ContactFormSubmit } from "./ContactFormSubmit";
import { ContactFormValidationMessage } from "./ContactFormValidationMessage";
import { FormFieldsSection } from "./FormFieldsSection";
import { OwnerFlag } from "./OwnerFlag";
import { PartnerSubscriptionOptIn } from "./PartnerSubscriptionOptIn";
import { SaveSearchOptIn } from "./SaveSearchOptIn";
import { ShareProfile } from "./SeekerProfile";
export const ContactForm = ({ onSubmit, loading, contactFormDatas, isModal, rootTestId = "ContactForm", avZone, }) => {
    const { t } = useI18n();
    const trackLeadFormKo = useTrackingLeadFormError();
    const testId = useContactingTestId(rootTestId);
    const { userInfoComplete, isOpen, userData, userCookieData } = useContactContext();
    const [validationErrors, setValidationErrors] = useState(undefined);
    const { openedContactForm } = useFeaturesEnabled();
    const onSubmitError = (errors) => {
        setValidationErrors(errors);
        Object.values(errors).forEach((error) => {
            trackLeadFormKo({ additionalProps: { av_error_code: error.message } });
        });
    };
    const { handleSubmit, control, reset, getValues } = useFormContext();
    const { contactCard, displayOwnerFlag } = contactFormDatas;
    const [hasSearchParameters, setHasSearchParameters] = useState(false);
    useEffect(() => {
        var _a;
        const hasSearchParameters = ((_a = new URL(window.location.href).searchParams.get("search")) === null || _a === void 0 ? void 0 : _a.length) > 0;
        setHasSearchParameters(hasSearchParameters);
    }, []);
    const isSaveSearchOptInEnabled = useFeatureEnabled("savedSearchOptIn") && hasSearchParameters;
    const isPartnerSubscriptionOptInEnabled = useFeatureEnabled("partnerSubscriptionOptIn");
    const showLegalText = isSaveSearchOptInEnabled || isPartnerSubscriptionOptInEnabled;
    useEffect(() => {
        const currentValue = getValues("newsletterOptInPreference");
        reset({
            ...getValues(),
            ...(userData !== null && userData !== void 0 ? userData : userCookieData),
            newsletterOptInPreference: currentValue || "email-sms",
        });
    }, [userData, userCookieData, reset, isOpen, getValues]);
    const renderRequiredFieldsMessage = () => {
        if (openedContactForm)
            return null;
        if (userInfoComplete)
            return null;
        return (_jsx(Box, { testId: `${testId}.RequiredFields`, marginBottom: "spacing.24", children: `* ${t("contact.form.required_fields")}` }));
    };
    return (_jsxs(_Fragment, { children: [!openedContactForm && (_jsx(ContactFormEnrichment, { testId: testId, contactCard: contactCard })), !openedContactForm && validationErrors && (_jsx(ContactFormValidationMessage, { testId: testId, errors: validationErrors })), renderRequiredFieldsMessage(), _jsxs(Box, { testId: testId, as: "form", onSubmit: handleSubmit(onSubmit, onSubmitError), children: [_jsx(FormFieldsSection, { contactFormDatas: contactFormDatas, rootTestId: rootTestId }), _jsx(ShareProfile, {}), _jsxs(Box, { children: [_jsx(OwnerFlag, { control: control, testId: testId, displayOwnerFlag: displayOwnerFlag }), _jsxs(Box, { children: [_jsx(PartnerSubscriptionOptIn, { control: control, testId: testId }), _jsx(SaveSearchOptIn, { control: control, testId: testId, isSaveSearchOptInEnabled: isSaveSearchOptInEnabled }), showLegalText && (_jsx(Box, { marginLeft: "spacing.4", paddingHorizontal: "spacing.16", children: _jsx(TooltipInfos, { text: t("contact.form.saved_search_opt_in.read_more"), content: t("contact.form.saved_search_opt_in.tooltip"), icon: _jsx(InfoCircleIcon, { size: "sizing.16" }) }) }))] })] }), _jsxs(Box, { paddingVertical: openedContactForm ? "spacing.16" : "spacing.24", children: [_jsx(ContactFormSubmit, { loading: loading, testId: testId, isPrivateOwner: contactFormDatas.contactCard.isPrivateOwner }), _jsx(ContactFormPlato, { showDivider: false, tracking: { avZone: avZone } }), _jsx(SuggestPriceButton, { rootTestId: testId, isModal: isModal })] }), _jsx(LegalText, {})] })] }));
};
